import { useEffect, useState } from "react";
import CreateStoreCollectionModal from "./CreateStoreCollectionModal";
import { toast } from "sonner";
import {
  api,
  getDesignProductTemplateByOrganization,
} from "../../../services/axios";
import { designAreaLabel } from "../../../utils/design-areas";

interface DesignProductTemplate {
  id: string;
  created_at: string;
  updated_at: string;
  handle: string;
  title: string;
  body_html: string;
  campaign: string;
  organization: string;
  file: string;
  sku: string;
  variants: string[];
  layers: string[];
  design_area: string;
  licensing: string[];
  stores: string[];
  college_names: string[];
  org_names: string[];
  org_salesforce_ids: string[];
  tags: string[];
  upis: string[];
  auto_run: boolean;
}

export default function DesignProducTemplate({
  salesforce_id,
}: {
  salesforce_id: string;
}) {
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [designProductTemplates, setDesignProductTemplates] = useState<
    DesignProductTemplate[]
  >([]);

  const loadTemplates = async () => {
    if (salesforce_id) {
      let result = (await getDesignProductTemplateByOrganization(
        String(salesforce_id)
      )) as DesignProductTemplate[];
      console.log("templates", result);
      setDesignProductTemplates(result);
    }
  };
  useEffect(() => {
    loadTemplates();
  }, [modalVisible, salesforce_id]);

  const deleteTemplate = async (template: string) => {
    await api
      .delete(`product-templates/${template}`)
      .then(() => {
        toast.success(`removed`, { duration: 5000 });
      })
      .catch((e) => {
        toast.error(e.message, { duration: 5000 });
      });
    return;
  };

  const runTemplate = async (template: string) => {
    await api
      .put(`product-templates/${template}`, {
        auto_run: true,
        updated_at: new Date().getTime().toString(),
      })
      .then(() => {
        toast.success("success", { duration: 5000 });
      })
      .catch((e) => {
        toast.error(e.message, { duration: 5000 });
      });
  };

  return (
    <div className="my-8  w-full border border-b  rounded ">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-xl font-semibold text-gray-900">
            Design Product Templates
          </h1>
        </div>
      </div>
      <div className="mt-8 flex flex-col">
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="relative whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-6"
                    ></th>
                    <th
                      scope="col"
                      className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      id
                    </th>
                    <th
                      scope="col"
                      className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Campaign
                    </th>
                    <th
                      scope="col"
                      className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Handle
                    </th>
                    <th
                      scope="col"
                      className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Title
                    </th>
                    <th
                      scope="col"
                      className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Design Area
                    </th>
                    <th
                      scope="col"
                      className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Sku
                    </th>
                    <th
                      scope="col"
                      className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Design File
                    </th>
                    <th
                      scope="col"
                      className="relative whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-6"
                    ></th>
                    <th
                      scope="col"
                      className="relative whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-6"
                    ></th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {designProductTemplates?.map(
                    (designProductTemplate, index) => (
                      <tr key={index}>
                        <td className="whitespace-nowrap py-2 pl-4 pr-3 text-sm text-gray-500 sm:pl-6">
                          {index + 1}
                        </td>
                        <td className="whitespace-nowrap py-2 pl-4 pr-3 text-sm text-gray-500 sm:pl-6">
                          {designProductTemplate.id}
                        </td>
                        <td className="whitespace-nowrap py-2 pl-4 pr-3 text-sm text-gray-500 sm:pl-6">
                          {designProductTemplate.campaign}
                        </td>
                        <td className="whitespace-nowrap py-2 pl-4 pr-3 text-sm text-gray-500 sm:pl-6">
                          {designProductTemplate.handle}
                        </td>
                        <td className="whitespace-nowrap py-2 pl-4 pr-3 text-sm text-gray-500 sm:pl-6">
                          {designProductTemplate.title}
                        </td>
                        <td className="whitespace-nowrap py-2 pl-4 pr-3 text-sm text-gray-500 sm:pl-6">
                          {designAreaLabel(designProductTemplate.design_area)}
                        </td>
                        <td className="whitespace-nowrap py-2 pl-4 pr-3 text-sm text-gray-500 sm:pl-6">
                          {designProductTemplate.sku}
                        </td>
                        <td className="whitespace-nowrap py-2 pl-4 pr-3 text-sm text-gray-500 sm:pl-6">
                          {designProductTemplate.file}
                        </td>
                        <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                          <button
                            onClick={() =>
                              deleteTemplate(designProductTemplate.id)
                            }
                          >
                            Delete
                          </button>
                        </td>
                        <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                          <button
                            onClick={() =>
                              runTemplate(designProductTemplate.id)
                            }
                          >
                            Run
                          </button>
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <CreateStoreCollectionModal
        salesforce_id={salesforce_id}
        visible={modalVisible}
        setVisible={setModalVisible}
      />
    </div>
  );
}
